function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

export default function() {
  return this.each(lower);
}



//////////////////
// WEBPACK FOOTER
// /srv/http/murdocktrust.org/releases/458/web/app/themes/murdock-serenity/node_modules/d3-selection/src/selection/lower.js
// module id = 462
// module chunks = 0